<template>
  <div>
    <v-btn icon id="close" @click.stop="close()">
      <v-icon>mdi-arrow-collapse-left</v-icon>
    </v-btn>
    <v-card
      v-if="
        this.$store.state.affiliations && this.$store.state.affiliations.length
      "
      flat
      color="transparent"
      id="filter-list"
      class="mb-12"
    >
      <v-subheader>{{ $t("sidenav.filter.filterByAffiliation") }}</v-subheader>
      <v-card-text>
        <v-select
          v-model="myFilters.affiliation"
          :items="this.$store.state.affiliations"
          :menu-props="{ maxHeight: '400' }"
          :label="$t('sidenav.filter.filterByAffiliationLabel')"
          multiple
          :hint="$t('sidenav.filter.filterByAffiliationHint')"
          persistent-hint
        ></v-select>
      </v-card-text>
    </v-card>
    <v-card flat color="transparent">
      <v-subheader>{{ $t("sidenav.filter.filterByYear") }}</v-subheader>
      <v-card-text>
        <v-row>
          <v-col class="pr-4">
            <v-range-slider
              v-model="myFilters.range"
              :min="myFilters.min"
              :max="myFilters.max"
              hide-details
              class="align-center"
            >
              <template v-slot:prepend>
                <v-text-field
                  v-model="myFilters.range[0]"
                  class="mt-0 pt-0"
                  hide-details
                  single-line
                  type="number"
                  style="width: 60px"
                ></v-text-field>
              </template>
              <template v-slot:append>
                <v-text-field
                  v-model="myFilters.range[1]"
                  class="mt-0 pt-0"
                  hide-details
                  single-line
                  type="number"
                  style="width: 60px"
                ></v-text-field>
              </template>
            </v-range-slider>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card
      v-if="this.$store.state.categories && this.$store.state.categories.length"
      flat
      color="transparent"
    >
      <v-subheader>{{ $t("sidenav.filter.filterByCategory") }}</v-subheader>
      <v-card-text>
        <v-chip-group v-model="myFilters.category" column multiple>
          <v-chip
            v-for="category in this.$store.state.categories"
            :key="category.id"
            filter
            outlined
            >{{ category.name }}</v-chip
          >
        </v-chip-group>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    filters: {
      required: true,
    },
  },
  computed: {
    drawer: {
      get() {
        return this.$store.state.sidenav;
      },
      set(val) {
        this.$store.commit("sidenav", val);
      },
    },
    myFilters: {
      get() {
        return this.filters;
      },
      set(val) {
        this.$emit("update-filters", val);
      },
    },
  },
  data: function () {
    return {};
  },
  mounted() {
    this.$store.dispatch("loadCategories"); // dispatch loading
    this.$store.dispatch("loadAffiliations"); // dispatch loading
  },
  methods: {
    close: function () {
      this.drawer = false;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
#close {
  position: absolute;
  top: 0;
  right: 0;
}
#filter-list {
  margin-top: 60px;
}
</style>